

import {
  mapActions,
} from 'vuex'

export default {
  name: 'WaitingListGetter',
  data() {
    return {
      isAuth: window.isUserAuthenticated,
    }
  },
  created() {
    if (this.isAuth) this.getWaitingListIds()
  },
  methods: {
    ...mapActions('waitinglist', [
      'getWaitingListIds',
    ]),
  },
  render() {
    return this.$scopedSlots.default({})
  },
}
